module.exports = __webpack_public_path__ + "static/media/14.5b101a7e.jpeg";